import React, { useEffect, useMemo, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import CustomHeader from './CustomHeader';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { useFoldersQuery } from 'modules/FileManagerV2/hooks/api/useFoldersQuery';
import { Controller, useForm } from 'react-hook-form';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import useUpdateFiles from 'modules/FileManagerV2/hooks/api/useUpdateFiles';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

function MoveItemModal() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const { addToast } = useToast();
  const { updateFiles } = useUpdateFiles();

  const { modals, isGlobalFileManager, fileManagerFilters, isLeadFileManager, selectedItem, caseDetails, breadCrumbs } =
    useFileManagerContext();
  const { moveItemModal, setMoveItemModal } = modals;
  const [folderList, setFolderList] = useState([]);

  console.log('selectedItem');

  const folderParams = useMemo(() => {
    let params = '';
    let caseId = 'undefined';

    if (isGlobalFileManager) {
      caseId = selectedItem?.case_id || fileManagerFilters?.case || 'undefined';
    } else {
      caseId = caseDetails?.case_id || 'undefined';
    }

    if (selectedItem.entry_type === 'folder') {
      params = `folder_id=${selectedItem.object_id}&case_id=${caseId}`;
    } else {
      params = `case_id=${caseId}`;
    }
    return params;
  }, [isGlobalFileManager, selectedItem, fileManagerFilters?.case, caseDetails?.case_id]);

  const { data: folders = [] } = useFoldersQuery(folderParams, moveItemModal);

  const moveFileHandler = async (data) => {
    if (data.folder === fileManagerFilters.selectedFolder) {
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.ERROR, toastConstant.message.FILE_MOVE_ERROR);
      return;
    }
    const updated_file = {
      folder_id: data.folder === 'root' ? '' : data.folder,
      pk: selectedItem['pk'],
      sk: selectedItem['sk'],
      type: selectedItem['entry_type'],
    };

    const obj = {
      data: updated_file,
      is_lead: isLeadFileManager,
    };

    try {
      await updateFiles(obj);
      // handleGetFiles(pageLimit);
      addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.FILE_MOVED_SUCCESS);
      setMoveItemModal(false);
    } catch (error) {
      console.log(error);
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.ERROR, toastConstant.message.FILE_MOVE_FAILED);
    }
  };

  const moveFooter = (
    <div className="footer-btn">
      <Button label="Cancel" onClick={() => setMoveItemModal(false)} className="p-button p-button-secondary outline mx-2" />
      <Button label="Move" onClick={handleSubmit(moveFileHandler)} className="p-button p-button-secondary" />
    </div>
  );

  useEffect(() => {
    const dropdownList = folders.filter((item) => Object.keys(item).length > 1);
    if (breadCrumbs.length > 0) {
      dropdownList.push({ label: 'Root directory', value: 'root' });
    }
    setFolderList(dropdownList);
  }, [folders, breadCrumbs]);

  return (
    <Dialog
      className="new-task-popup"
      header={<CustomHeader onHide={() => setMoveItemModal(false)} />}
      footer={moveFooter}
      visible={moveItemModal}
      style={{ width: '40vw' }}
      modal
      onHide={() => setMoveItemModal(false)}
      closable={false}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="modal-heading F-size16 text-bold">{selectedItem.entry_type === 'folder' ? 'Move Folder' : 'Move File'}</div>
      </div>

      <div className="P-medium">
        {selectedItem.entry_type === 'folder' ? 'Folder Name' : 'File Name'} : {selectedItem.display_name}
      </div>
      <Controller
        name="folder"
        control={control}
        defaultValue={[]}
        rules={{ required: true }}
        render={({ field }) => (
          <Dropdown
            className="input-shadow mb-2 mt-2 w-100 F-size14"
            placeholder={'Target Folder'}
            onChange={(e) => {
              field.onChange(e.value);
            }}
            id={field.name}
            value={field.value}
            options={folderList.filter((folder) => folder?.value !== selectedItem?.folder_id)}
            isSearchable
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        )}
      />
      {errors?.folder && <InputErrorMessage>Select folder</InputErrorMessage>}
    </Dialog>
  );
}

export default MoveItemModal;
